var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "more-box__qty"
};
var _hoisted_2 = {
    key: 0,
    class: "filt-box__top"
};
var _hoisted_3 = { class: "form-group" };
var _hoisted_4 = { class: "form-field form-field--text form-field--3 form-field--s form-field--primary" };
var _hoisted_5 = { class: "form-field__side form-field__side--left" };
var _hoisted_6 = ["placeholder"];
var _hoisted_7 = { class: "filt-box__main" };
var _hoisted_8 = { class: "filt-box__list list" };
var _hoisted_9 = { class: "switch checkbox checkbox--s" };
var _hoisted_10 = { class: "switch__main" };
var _hoisted_11 = ["checked", "disabled", "onChange"];
var _hoisted_12 = { class: "switch__cover checkbox__cover" };
var _hoisted_13 = {
    class: "svg",
    width: "16",
    height: "16"
};
var _hoisted_14 = ["href"];
var _hoisted_15 = { class: "switch__label checkbox__label" };
var _hoisted_16 = {
    key: 0,
    class: "filt-box__extra"
};
import { computed, ref, toRaw } from "vue";
import { escapeRegex } from "../../../utils";
import Icon from "../../../components/Icon.vue";
import ItemWrapper from "./ItemWrapper.vue";
import { FilterItemTypes } from "../types";
import { spriteHref } from "../../../components/sprites";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OptionsList',
    props: {
        item: { type: Object, required: true },
    },
    emits: ["update"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var filter = ref('');
        var showFilter = ref(false);
        var showHidden = ref(false);
        var emit = __emit;
        var count = computed(function () { return props.item.options.reduce(function (sum, option) { return sum + (option.selected ? 1 : 0); }, 0); });
        if (props.item.type === FilterItemTypes.FilterableList) {
            showFilter.value = true;
        }
        else {
            showHidden.value = true;
        }
        if (props.item.options.length < 50) {
            showFilter.value = false;
            showHidden.value = true;
        }
        var visibleOptions = computed(function () {
            var _a;
            if (showHidden.value && filter.value === '' || !showFilter.value) {
                return props.item.options;
            }
            var filteredText = ((_a = filter.value) === null || _a === void 0 ? void 0 : _a.trim()) || '';
            if (filteredText) {
                var pieces = escapeRegex(filteredText).split(new RegExp("[ .&-'`()]+", 'ui'));
                var regexp_1 = new RegExp("(^|\\W)" + pieces.join('.*\\W'), 'ui');
                return props.item.options.filter(function (option) { return option.name.match(regexp_1); });
            }
            return props.item.options.filter(function (option) { return showHidden.value || option.top || option.selected; });
        });
        var sortedOptions = computed(function () {
            if (!props.item.active || props.item.options.length <= 5) {
                return visibleOptions.value;
            }
            return toRaw(visibleOptions.value).sort(function (a, b) {
                if ((a.pinned !== undefined ? a.pinned : a.selected) !== (b.pinned !== undefined ? b.pinned : b.selected)) {
                    return a.selected ? -1 : 1;
                }
                return 0;
            });
        });
        function expand() {
            showHidden.value = true;
        }
        function onchange(option, selected) {
            var e_1, _a;
            option.pinned = !selected;
            option.selected = selected;
            var active = false;
            try {
                for (var _b = __values(props.item.options), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var option_1 = _c.value;
                    if (option_1.selected) {
                        active = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            props.item.active = active;
            emit('update', true);
        }
        function reset() {
            var e_2, _a;
            if (!props.item.active) {
                return;
            }
            try {
                for (var _b = __values(props.item.options), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var option = _c.value;
                    if (option.selected) {
                        option.selected = false;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            props.item.active = false;
            emit('update', false);
        }
        return function (_ctx, _cache) {
            return (__props.item.options.length)
                ? (_openBlock(), _createBlock(ItemWrapper, {
                    key: 0,
                    item: __props.item,
                    onReset: reset
                }, {
                    badge: _withCtx(function () { return [
                        (__props.item.active)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(count.value), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ]; }),
                    body: _withCtx(function () { return [
                        (showFilter.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createVNode(Icon, {
                                                name: "search",
                                                "class-name": "form-icon"
                                            })
                                        ]),
                                        _cache[1] || (_cache[1] = _createTextVNode()),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: __props.item.placeholder,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((filter).value = $event); })
                                        }, null, 8 /* PROPS */, _hoisted_6), [
                                            [_vModelText, filter.value]
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("ul", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedOptions.value, function (option) {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "filt-box__item list__item",
                                        key: option.value
                                    }, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("label", _hoisted_10, [
                                                _createElementVNode("input", {
                                                    type: "checkbox",
                                                    class: "switch__input",
                                                    checked: option.selected,
                                                    disabled: !option.available,
                                                    onChange: function ($event) { return (onchange(option, $event.target.checked)); }
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_11),
                                                _cache[2] || (_cache[2] = _createTextVNode()),
                                                _createElementVNode("span", _hoisted_12, [
                                                    (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                                                        _createElementVNode("use", {
                                                            href: _unref(spriteHref)('check-16')
                                                        }, null, 8 /* PROPS */, _hoisted_14)
                                                    ]))
                                                ]),
                                                _cache[3] || (_cache[3] = _createTextVNode()),
                                                _createElementVNode("span", _hoisted_15, _toDisplayString(option.name), 1 /* TEXT */)
                                            ])
                                        ])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _cache[5] || (_cache[5] = _createTextVNode()),
                            (showFilter.value && !showHidden.value && !filter.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("div", { class: "filt-box__more-link" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn--4 btn--s btn--black",
                                            onClick: expand
                                        }, __spreadArray([], __read((_cache[4] || (_cache[4] = [
                                            _createElementVNode("span", { class: "btn__label" }, "Показать все", -1 /* CACHED */)
                                        ]))), false))
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]; }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["item"]))
                : _createCommentVNode("v-if", true);
        };
    }
});
